import React from "react";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../routes";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] bg-gray-100 text-center px-4">
      <h1 className="text-4xl font-bold text-red-600 mb-4">Access Denied</h1>
      <p className="text-gray-700 text-lg mb-6">
        You do not have permission to view this page.
      </p>
      <button
        onClick={() => navigate(HOME)}
        className="bg-primary hover:bg-gray-600 text-white px-6 py-3 rounded shadow font-semibold"
      >
        Go to Home
      </button>
    </div>
  );
};

export default AccessDenied;
